import * as React from 'react'

export const HeadingThreeIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M22.7925 11.5554C22.7925 12.2913 22.5696 12.917 22.1238 13.4326C21.678 13.9482 21.0522 14.3027 20.2466 14.4961V14.5444C21.1973 14.6626 21.917 14.9526 22.4058 15.4146C22.8945 15.8711 23.1389 16.4888 23.1389 17.2676C23.1389 18.4009 22.728 19.2844 21.9062 19.9182C21.0845 20.5466 19.9109 20.8608 18.3855 20.8608C17.1072 20.8608 15.9739 20.6487 14.9856 20.2244V18.1055C15.4421 18.3364 15.9443 18.5244 16.4922 18.6694C17.04 18.8145 17.5825 18.887 18.1196 18.887C18.9414 18.887 19.5483 18.7473 19.9404 18.468C20.3325 18.1887 20.5286 17.7402 20.5286 17.1226C20.5286 16.5693 20.303 16.1772 19.8518 15.9463C19.4006 15.7153 18.6809 15.5999 17.6926 15.5999H16.7983V13.6904H17.7087C18.6218 13.6904 19.2878 13.5723 19.7068 13.3359C20.1311 13.0942 20.3433 12.6833 20.3433 12.1033C20.3433 11.2117 19.7847 10.7659 18.6675 10.7659C18.2808 10.7659 17.886 10.8303 17.4832 10.9592C17.0857 11.0881 16.6426 11.311 16.1538 11.6279L15.0017 9.91187C16.0759 9.13843 17.3569 8.75171 18.8447 8.75171C20.064 8.75171 21.0254 8.99878 21.729 9.49292C22.438 9.98706 22.7925 10.6746 22.7925 11.5554Z'
        fill='currentColor'
      />
      <path
        d='M3.85718 2.69971V9.44971H9.85718V2.69971H12.8572V20.6997H9.85718V12.8247H3.85718V20.6997H0.857178V2.69971H3.85718Z'
        fill='currentColor'
      />
    </svg>
  )
})

HeadingThreeIcon.displayName = 'HeadingThreeIcon'
